import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export const {
  getError: getMerchantsError,
  getItemsIds: getMerchantIds,
  getItemsMeta: getMerchantsMeta,
  getItemsTotalCount: getMerchantsTotalCount,
  isLoadingItems: isLoadingMerchants,
} = itemsDuck.selectors;

export const { getFilters, getPage, getLimit, getSort } = queryDuck.selectors;
